import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Chip } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
import { EntryPickerDialog } from 'app/domains/common-ui/pickers';
export function FilesystemEntriesField(props) {
    const { label, secondary, appearance, chipAction, initiallyOpen = false } = props;
    const { values, setFieldValue, submitForm } = useFormikContext();
    const [renderPicker, setRenderPicker] = useState(initiallyOpen);
    const showPicker = () => {
        setRenderPicker(true);
    };
    const hidePicker = () => {
        setRenderPicker(false);
    };
    const handleSubmit = (entries) => {
        const ids = entries.map(({ id }) => id);
        setFieldValue('value', ids);
        submitForm();
        hidePicker();
    };
    return (<Fragment>
      <Chip size="medium" appearance={appearance} label={label} secondary={secondary} onClick={showPicker} action={chipAction}/>

      {renderPicker && (<EntryPickerDialog multiselect initialEntryIds={values.value} dialogTitle={t({
                message: 'Select related documents',
                comment: 'Metadata: Filesystem entries picker dialog title',
            })} submitLabel={t({
                message: 'Select',
                comment: 'Metadata: Filesystem entries picker dialog submit button label',
            })} onClose={hidePicker} onSubmit={handleSubmit}/>)}
    </Fragment>);
}
